import { Component } from "@angular/core";

import { ApplicationWizardState } from "../models";
import { ApplicationWizardService, prettyPrint } from "../../application-wizard/application-wizard.service";
import { TranslateService } from "../../../../common/translate/translate.service";
import { SnackbarService } from "../../../../common/snackbar/snackbar.service";
import { AbstractWizardStepComponent } from "../../../wizard-dialog/abstract-wizard-step.component";
import { ApplicationImageSelectComponent } from "../application-image-select/application-image-select.component";
import { ApplicationImage } from "../../../../models";
import { Resource } from "@impulse/sdp-shared-models";

@Component({
	templateUrl: "./application-wizard-summary.component.html"
})
export class ApplicationWizardSummaryComponent extends AbstractWizardStepComponent<void> {
	public applicationState: ApplicationWizardState;
	public applicationImage: ApplicationImage;

	private isSaving = false;

	constructor(
		private service: ApplicationWizardService,
		private translateService: TranslateService,
		private snackbarService: SnackbarService
	) {
		super();
		this.applicationState = service.newApplicationState();
		this.applicationState = this.service.applicationState;
		this.applicationImage = {
			name: this.applicationState.application.name,
			imageBase64: this.applicationState.application.image
		};
	}

	public get title() {
		return "application.wizard.summary.title";
	}

	public get description() {
		return this.service.applicationState.isCreate ?
			"applicaiton.wizard.summary.description.create" : "applicaiton.wizard.summary.description.update";
	}

	public get nextStep(): AbstractWizardStepComponent.ConstructorFunction<void> | undefined {
		return undefined;
	}

	public get previousStep() {
		return ApplicationImageSelectComponent;
	}

	public get isFormValid() {
		return true;
	}

	public performPrevious() { }

	public async performNext() {
		this.isSaving = true;
		try {
			await this.service.processApplication();
		} catch (e) {
			this.snackbarService.open(this.translateService.translate(e));
		} finally {
			this.isSaving = false;
		}
	}

	public get showProgressBar() {
		return this.isSaving;
	}

	public prettyPrintPort(port: Resource.Port) {
		return `${prettyPrint(port)}/${port.proto.toUpperCase()}`;
	}
}
